



import TransferDom from 'vux/src/directives/transfer-dom/index.js'

var  map = {

}

import Footer from '../components/footer.vue'
import {
SaunaKanbanQuery,
SaunaConsumeDetailQuery,
MemberKanbanQuery,

} from '../../static/js/api.js'

function loadtotal(that) {


SaunaKanbanQuery({}, function (res) {
console.log(res)
if (res.data.IsSuccess) {

that.data = JSON.parse(res.data.Result)


var circleData=[];
var mapData={};



var arr = JSON.parse(JSON.stringify(that.data.ConsumeDetails));
function maxarr(arr,len){
var max = [];
arr.sort(function(a,b){
return a.Money-b.Money;
});
for(var i=0;i<len;i++){
max.push(arr.pop());
}
return max;
}



var datassss=arr

for(var i=0;i<datassss.length;i++){
var item=datassss[i]
var newCircle={
name: item.CatalogueName,
percent: item.Money/that.data.ConsumeSummary.Money.toFixed(4),
a: '1'

}
mapData[item.CatalogueName]=((item.Money/that.data.ConsumeSummary.Money).toFixed(4) * 100).toFixed(2)+ '%'
circleData.push(newCircle)


}
that.datas=circleData
map=mapData
that.showChart=true


const chart = new that.F2.Chart({
id: 'boxCanvas',
pixelRatio: window.devicePixelRatio
});
chart.source(circleData, {
percent: {
formatter: function formatter(val) {
return val * 100 + '%';
}
}
});
chart.legend({
position: 'bottom',
align: 'center',
itemFormatter: function itemFormatter(val) {
return val + '  ' + map[val];
}
});
chart.tooltip(false);
chart.coord('polar', {
transposed: true,
radius: 0.85
});
chart.axis(false);
chart.interval()
.position('a*percent')
.color('name', [ '#1890FF', '#13C2C2', '#2FC25B', '#FACC14', '#F04864', '#8543E0',"#8AC6D1","#BBDED6","#FAE3D9","#FFB6B9","#f768a2","#fb6a49","#79c77a","#9f9bc9","#979797"])
.adjust('stack')
.style({
lineWidth: 1,
stroke: '#fff',
lineJoin: 'round',
lineCap: 'round'
})
.animate({
appear: {
duration: 1200,
easing: 'bounceOut'
}
});

chart.render();






MemberKanbanQuery({}, function (ress) {
console.log(ress)
if (ress.data.IsSuccess) {

that.data.PayDetails = JSON.parse(ress.data.Result).PayDetails
console.log(that.data)
} else {

that.$vux.toast.text('数据获取失败，请重试', 'middle')

}


})



that.loading=false

console.log(that.data)
} else {

that.$vux.toast.text('数据获取失败，请重试', 'middle')

}


})

}


export default {
name: 'app',
directives: {
TransferDom
},
components: {
'pc-footer': Footer
},
data() {
return {
showAlert:false,
loading:true,
selectItem:{},
legendOptions: {
position: 'right',
itemFormatter (val) {
return val + '  ' + map[val]
}
},
yOptions: {
formatter (val) {
return val * 100 + '%'
}
},
map,
datas: [

],
showTable:[],
data: {
GuestFlows: {},
BarConsumeDetails: {},
BarConsumeSummary: {},
ConsumeDetails: {},
ConsumeSummary: {},
GuestPerConsume: {},
HandCardUsed: {},
MemberUsedDetail: {},
MemberUsedSummary: {},
NewMemberDetails: {},
NewMemberSummary: {},
PayModeDetails: {},
PayModeSummary: {
Money:1
},
PrepaidMemberDetails: {},
PrepaidMemberSummary: {},
PayDetails: {},

},
showChart:false,
selected:1,
selectedsr:1,
msg: 'Welcome to Your Vue.js App',
nav:[
{
id:1,
name:"人数统计"

},
{
id:2,
name:"收入情况"

},
{
id:3,
name:"销售类别"

},{
id:4,
name:"吧台统计"

}

],
navsr:[

{
id:1,
name:"销售类别"

}


]
}
},

mounted() {
var that = this
loadtotal(that)


},
methods:{
toAlert(e){
var that=this
that.selectItem=e;
that.showAlert=true
SaunaConsumeDetailQuery({
CataCode:e.CatalogueCode,
IsCurrent:true
}, function (ress) {
console.log(ress)
console.log(JSON.parse(ress.data.Result))
if (ress.data.IsSuccess) {

var arr = JSON.parse(ress.data.Result).ConsumeDetails

var count = 0
for(var i=0;i<arr.length;i++){
if(arr[i].GoodsCode==14001) count++;
}
console.log(count)
var obj = {}, newArr = [];
arr.forEach(function (item, suffix) {

if (!obj[item.GoodsCode]) {
var arr = [];
arr.push(item);
newArr.push(arr);
obj[item.GoodsCode] = item;
} else {
newArr.forEach(function (value, index) {

if (value[0].GoodsCode == item.GoodsCode) {
value.push(item)
}
})
}
})

var nnArr = []
for(let s of newArr){
if(s.length>1){

var newS = {
Count:0,
GoodsName: s[0].GoodsName,
Money: 0
}

for(let ss of s ){
var totalCount = (newS.Count*1+ss.Count*1)

newS.Count=totalCount.toFixed(0)
var totalMoney =  (newS.Money*1+ss.Money*1)
newS.Money=totalMoney.toFixed(2)

}
nnArr.push(newS)
}else{
nnArr.push(s[0])

}

}

console.log(nnArr)
that.showTable=nnArr

} else {

that.$vux.toast.text('数据获取失败，请重试', 'middle')

}


})

},
refresh(){
this.loading=true
var that=this
loadtotal(that)


},
change(index){
console.log(index)
this.selected= parseInt(index+1)

},

changesr(index){
console.log(index)
this.selectedsr= parseInt(index+1)

},
dateFormat:function(time) {
var date=new Date(time);
var year=date.getFullYear();
/* 在日期格式中，月份是从0开始的，因此要加0
* 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
* */
var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();

return month+"-"+day+" "+hours+":"+minutes+":"+seconds;
}


}

}



// WEBPACK FOOTER //
// ./src/pages/xs.vue